import { ROUTE_PATHS } from '@config/routes';

export const MERCHANT_CONFIG_DESTINATION = {
  SEARCH_BUSINESS: 'search-business',
  DASHBOARD: 'dashboard',
  WAITING_DASHBOARD: 'waiting-dashboard',
};

/** Safely coerce config totalBusinessCount (null, undefined, '', NaN → 0). */
export const parseTotalBusinessCount = (value) => {
  if (value == null || value === '') return 0;

  const count = Number(value);
  return Number.isFinite(count) && count > 0 ? count : 0;
};

/**
 * Resolves merchant navigation from app config API fields.
 * Exactly one destination is returned per config payload.
 * All destinations map to Setup Guide for merchant home landing.
 */
export const resolveMerchantConfigDestination = (config = null) => {
  if (!config) return null;

  const hasApprovedBusiness = Boolean(config.hasApprovedBusiness);
  const totalBusinessCount = parseTotalBusinessCount(config.totalBusinessCount);

  if (!hasApprovedBusiness && totalBusinessCount === 0) {
    return MERCHANT_CONFIG_DESTINATION.SEARCH_BUSINESS;
  }

  if (hasApprovedBusiness && totalBusinessCount > 0) {
    return MERCHANT_CONFIG_DESTINATION.DASHBOARD;
  }

  if (!hasApprovedBusiness && totalBusinessCount > 0) {
    return MERCHANT_CONFIG_DESTINATION.WAITING_DASHBOARD;
  }

  if (hasApprovedBusiness) {
    return MERCHANT_CONFIG_DESTINATION.DASHBOARD;
  }

  return MERCHANT_CONFIG_DESTINATION.SEARCH_BUSINESS;
};

export const getRouteForMerchantConfigDestination = (destination) => {
  switch (destination) {
    case MERCHANT_CONFIG_DESTINATION.SEARCH_BUSINESS:
    case MERCHANT_CONFIG_DESTINATION.DASHBOARD:
    case MERCHANT_CONFIG_DESTINATION.WAITING_DASHBOARD:
      // New and existing merchants always land on Setup Guide / tutorial.
      return ROUTE_PATHS.SETUP_GUIDE;
    default:
      return null;
  }
};

export default resolveMerchantConfigDestination;
